import { type AnyAction, createSlice, EntityId } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { Feed } from '~/redux/actionTypes';
import createLegoAdapter from '~/redux/legoAdapter/createLegoAdapter';
import { EntityType } from '~/redux/models/entities';
import type { RootState } from '~/redux/rootReducer';

const legoAdapter = createLegoAdapter(EntityType.FeedActivities);

const feedActivitiesSlice = createSlice({
  name: EntityType.FeedActivities,
  initialState: legoAdapter.getInitialState(),
  reducers: {},
  extraReducers: legoAdapter.buildReducers({
    fetchActions: [Feed.FETCH],
    extraCases: (addCase) => {
      addCase('SOCKET_NEW_NOTIFICATION', (state, action: AnyAction) => {
        legoAdapter.upsertOne(state, action.payload);
      });
    },
  }),
});

export default feedActivitiesSlice.reducer;

export const { selectEntities: selectFeedActivityEntities } =
  legoAdapter.getSelectors((state: RootState) => state.feedActivities);

export const selectFeedActivitiesByIds = createSelector(
  selectFeedActivityEntities,
  (_: RootState, ids: EntityId[]) => ids,
  (entities, ids) => ids.map((id) => entities[id]),
);
